module.exports = __webpack_public_path__ + "img/pr-3.680718e5.png";